// camada do celular. cada parte liga abaixo de 1024px e desliga quando a janela cruza o limite,
// para o desktop nunca herdar estado do celular.
(() => {
  const celular = window.matchMedia('screen and (max-width: 1023.98px)');
  // o configurador de kit muda de desenho em 990px: até ali ele ainda tem o resumo fixo ao lado
  const configurador = window.matchMedia('screen and (max-width: 989.98px)');
  const raiz = document.documentElement;
  const partes = [];
  const ligadas = new Set();

  function sincronizar() {
    for (const parte of partes) {
      const vale = (parte.midia || celular).matches;
      if (vale && !ligadas.has(parte)) {
        parte.ligar();
        ligadas.add(parte);
      } else if (!vale && ligadas.has(parte)) {
        parte.desligar();
        ligadas.delete(parte);
      }
    }
  }

  // ---------- barra inferior ----------

  function barraInferior() {
    const nav = document.querySelector('[data-nt-m-nav]');
    if (!nav) return null;
    const botaoMenu = nav.querySelector('[data-nt-m-menu]');
    const linkSacola = nav.querySelector('[data-nt-sacola-abrir]');
    const conta = nav.querySelector('[data-nt-m-conta]');
    const gaveta = document.querySelector('details.nt-drawer');
    const painel = gaveta && gaveta.querySelector('.nt-drawer__panel');
    let observador = null;
    let pedido = 0;
    let abriuPeloBotao = false;

    const refletirMenu = () => {
      const aberto = !!(gaveta && gaveta.open);
      botaoMenu.setAttribute('aria-expanded', String(aberto));
      raiz.classList.toggle('nt-m-menu-aberto', aberto);
      if (aberto && abriuPeloBotao && painel) {
        const primeiro = painel.querySelector('a[href]');
        if (primeiro) primeiro.focus();
      }
      abriuPeloBotao = false;
    };
    const fecharMenu = () => {
      if (gaveta && gaveta.open) gaveta.open = false;
    };
    const alternarMenu = () => {
      if (!gaveta) return;
      abriuPeloBotao = !gaveta.open;
      gaveta.open = !gaveta.open;
    };
    const tecla = (evento) => {
      if (evento.key === 'Escape' && gaveta && gaveta.open) {
        gaveta.open = false;
        botaoMenu.focus();
      }
    };
    // link de âncora rola a página por trás; a gaveta precisa sair da frente
    const cliqueNoPainel = (evento) => {
      if (evento.target.closest('a[href]')) fecharMenu();
    };
    // a sacola abre por cima de tudo; o menu embaixo dela não tem mais serventia
    const cliqueNaBarra = (evento) => {
      if (evento.target.closest('[data-nt-sacola-abrir]')) fecharMenu();
    };

    const ehCampo = (el) => !!el && el instanceof Element && (
      el.matches('textarea, select, [contenteditable=""], [contenteditable="true"]') ||
      (el.matches('input') && !/^(checkbox|radio|button|submit|reset|range|color|file|image|hidden)$/i.test(el.type))
    );
    const entrouFoco = (evento) => raiz.classList.toggle('nt-m-digitando', ehCampo(evento.target));
    const saiuFoco = (evento) => raiz.classList.toggle('nt-m-digitando', ehCampo(evento.relatedTarget));

    const escreverConta = (n) => {
      conta.textContent = String(n);
      conta.hidden = !n;
      linkSacola.setAttribute('aria-label', n ? `Sacola, ${n} ${n === 1 ? 'item' : 'itens'}` : 'Sacola');
    };
    // a cotação de frete põe uma linha provisória na sacola vazia; ela não é compra e não entra na conta
    const lerSacola = () => {
      const meu = ++pedido;
      return fetch('/cart.js', { headers: { accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((sacola) => {
          if (!sacola || meu !== pedido) return;
          const n = (sacola.items || [])
            .filter((i) => !(i.properties && i.properties._nt_frete))
            .reduce((soma, i) => soma + i.quantity, 0);
          escreverConta(n);
        })
        .catch(() => {});
    };
    // voltou pelo botão de voltar: a página sai do cache do navegador com o número e o menu de quando saiu
    const voltou = (evento) => {
      if (!evento.persisted) return;
      fecharMenu();
      lerSacola();
    };

    return {
      ligar() {
        if (painel) {
          painel.id = painel.id || 'nt-m-gaveta';
          botaoMenu.setAttribute('aria-controls', painel.id);
        }
        refletirMenu();
        botaoMenu.addEventListener('click', alternarMenu);
        nav.addEventListener('click', cliqueNaBarra);
        if (gaveta) gaveta.addEventListener('toggle', refletirMenu);
        if (painel) painel.addEventListener('click', cliqueNoPainel);
        document.addEventListener('keydown', tecla);
        document.addEventListener('focusin', entrouFoco);
        document.addEventListener('focusout', saiuFoco);
        window.addEventListener('pageshow', voltou);
        window.addEventListener('pagehide', fecharMenu);
        // o tema não avisa quando o carrinho muda sem recarregar; a chamada à api do carrinho aparece aqui
        if ('PerformanceObserver' in window) {
          observador = new PerformanceObserver((lista) => {
            const mexeu = lista.getEntries().some((e) => /\/cart\/(add|change|update|clear)(\.js)?$/.test(new URL(e.name, location.href).pathname));
            if (mexeu) lerSacola();
          });
          try { observador.observe({ type: 'resource' }); } catch (e) { observador = null; }
        }
      },
      desligar() {
        botaoMenu.removeEventListener('click', alternarMenu);
        nav.removeEventListener('click', cliqueNaBarra);
        if (gaveta) gaveta.removeEventListener('toggle', refletirMenu);
        if (painel) painel.removeEventListener('click', cliqueNoPainel);
        document.removeEventListener('keydown', tecla);
        document.removeEventListener('focusin', entrouFoco);
        document.removeEventListener('focusout', saiuFoco);
        window.removeEventListener('pageshow', voltou);
        window.removeEventListener('pagehide', fecharMenu);
        if (observador) observador.disconnect();
        observador = null;
        fecharMenu();
        botaoMenu.setAttribute('aria-expanded', 'false');
        botaoMenu.removeAttribute('aria-controls');
        if (painel && painel.id === 'nt-m-gaveta') painel.removeAttribute('id');
        raiz.classList.remove('nt-m-menu-aberto', 'nt-m-digitando');
      },
    };
  }

  // ---------- barra de compra ----------

  // a barra só espelha o resumo do configurador: preço, parcela e rótulo continuam sendo escritos pelo
  // script da seção, e o toque aqui aciona o botão original, que já sabe adicionar à sacola ou abrir a reserva.
  // com dois configuradores na mesma página a barra não saberia qual comprar; cada resumo fica com o próprio botão
  function barraCompra() {
    const kits = document.querySelectorAll('nt-buy-kit');
    if (kits.length !== 1) return null;
    const kit = kits[0];
    const cta = kit.querySelector('[data-nt-cta]');
    if (!cta) return null;
    const total = kit.querySelector('[data-nt-total]');
    const notaPix = kit.querySelector('[data-nt-pix-nota]');
    const parcela = kit.querySelector('[data-nt-parcela]');
    const frase = parcela && parcela.closest('p');
    const rotulo = kit.querySelector('[data-nt-cta-rot]') || cta;

    const criar = (tag, classe) => {
      const el = document.createElement(tag);
      el.className = classe;
      return el;
    };
    const barra = criar('div', 'nt-m-compra');
    barra.setAttribute('role', 'region');
    barra.setAttribute('aria-label', 'Compra');
    const precos = criar('div', 'nt-m-compra__precos');
    precos.setAttribute('aria-live', 'polite');
    precos.setAttribute('aria-atomic', 'true');
    const linha = criar('p', 'nt-m-compra__linha');
    const valor = criar('strong', 'nt-m-compra__total');
    valor.setAttribute('data-nt-m-compra-total', '');
    const pix = criar('span', 'nt-m-compra__pix');
    pix.textContent = 'no Pix';
    const vezes = criar('p', 'nt-m-compra__parcela');
    const botao = criar('button', 'nt-m-compra__cta');
    botao.type = 'button';
    botao.setAttribute('data-nt-m-compra-cta', '');
    linha.append(valor, pix);
    precos.append(linha, vezes);
    barra.append(precos, botao);

    const texto = (no) => (no ? no.textContent.replace(/\s+/g, ' ').trim() : '');
    // só escreve o que mudou: reescrever o mesmo valor faria o leitor de tela anunciar o preço de novo
    const trocar = (no, novo) => {
      if (no.textContent !== novo) no.textContent = novo;
    };
    // combinação que não existe no catálogo: o configurador tira o preço da tela, e a barra também
    const desenhar = () => {
      precos.hidden = kit.classList.contains('is-sem-combo');
      trocar(valor, texto(total));
      pix.hidden = !notaPix || notaPix.hidden;
      trocar(vezes, texto(frase));
      vezes.hidden = !frase;
      trocar(botao, texto(rotulo));
      botao.disabled = cta.disabled;
      // enquanto o cupom é gravado na sacola o botão do resumo está ocupado, e a barra também
      if (cta.getAttribute('aria-busy') === 'true') botao.setAttribute('aria-busy', 'true');
      else botao.removeAttribute('aria-busy');
    };
    const acionar = () => {
      if (cta.getAttribute('aria-busy') === 'true') return;
      cta.click();
    };
    const observador = new MutationObserver(desenhar);
    const voltou = (evento) => {
      if (evento.persisted) desenhar();
    };

    return {
      midia: configurador,
      kit,
      ligar() {
        desenhar();
        // logo depois do configurador, para o botão vir na ordem de leitura e de tab depois das escolhas
        (kit.closest('.shopify-section') || document.body).append(barra);
        // o preço e o botão do resumo só saem quando a barra existe de fato
        raiz.classList.add('nt-m-compra-on');
        botao.addEventListener('click', acionar);
        observador.observe(kit, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'hidden', 'disabled', 'aria-busy'],
        });
        window.addEventListener('pageshow', voltou);
      },
      desligar() {
        observador.disconnect();
        botao.removeEventListener('click', acionar);
        window.removeEventListener('pageshow', voltou);
        raiz.classList.remove('nt-m-compra-on');
        barra.remove();
      },
    };
  }

  // ---------- galeria do configurador ----------

  // no celular as fotos passam de lado com o dedo. o radio de cada foto continua dizendo qual está na tela,
  // então as setas e o teclado seguem funcionando, e o desktop volta na mesma foto
  function galeria(caixa) {
    const palco = caixa.querySelector('.nt-kit__palco');
    if (!palco) return null;
    const radios = [...palco.querySelectorAll(':scope > .nt-kit__radio')];
    if (radios.length < 2) return null;
    const quadros = radios.map((r) => r.nextElementSibling);
    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

    const pontos = document.createElement('div');
    pontos.className = 'nt-m-galeria__pontos';
    pontos.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < radios.length; i++) {
      const ponto = document.createElement('span');
      ponto.className = 'nt-m-galeria__ponto';
      pontos.append(ponto);
    }
    let vigia = null;
    // foto para onde a seta mandou: no caminho o palco passa pelas do meio, e elas não podem virar a marcada
    let destino = -1;
    const soltar = () => {
      destino = -1;
    };

    const atual = () => Math.max(0, radios.findIndex((r) => r.checked));
    const marcar = (i) => {
      [...pontos.children].forEach((ponto, n) => ponto.classList.toggle('is-atual', n === i));
    };
    const irPara = (i, animar) => {
      const suave = animar && !semMovimento.matches && Math.round(palco.scrollLeft / palco.clientWidth) !== i;
      destino = suave ? i : -1;
      palco.scrollTo({ left: i * palco.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      marcar(i);
    };
    const viu = (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting || entrada.intersectionRatio < 0.6) continue;
        const i = quadros.indexOf(entrada.target);
        if (destino >= 0 && i !== destino) continue;
        destino = -1;
        radios[i].checked = true;
        marcar(i);
      }
    };
    // a seta da seção marca o radio sem avisar ninguém; este clique chega depois e leva o palco até a foto
    const clique = (evento) => {
      if (evento.target.closest('[data-nt-foto]')) irPara(atual(), true);
    };
    const trocou = (evento) => {
      const i = radios.indexOf(evento.target);
      if (i >= 0) irPara(i, true);
    };

    return {
      midia: configurador,
      kit: caixa.closest('nt-buy-kit'),
      ligar() {
        caixa.append(pontos);
        irPara(atual(), false);
        vigia = new IntersectionObserver(viu, { root: palco, threshold: 0.6 });
        quadros.forEach((quadro) => vigia.observe(quadro));
        caixa.addEventListener('click', clique);
        palco.addEventListener('change', trocou);
        // o dedo no meio da animação retoma o controle
        for (const tipo of ['pointerdown', 'touchstart', 'wheel']) palco.addEventListener(tipo, soltar, { passive: true });
      },
      desligar() {
        if (vigia) vigia.disconnect();
        vigia = null;
        destino = -1;
        caixa.removeEventListener('click', clique);
        palco.removeEventListener('change', trocou);
        for (const tipo of ['pointerdown', 'touchstart', 'wheel']) palco.removeEventListener(tipo, soltar, { passive: true });
        pontos.remove();
      },
    };
  }

  const partesDoKit = () => [barraCompra(), ...[...document.querySelectorAll('nt-buy-kit .nt-kit__galeria')].map(galeria)];
  for (const parte of [barraInferior(), ...partesDoKit()]) {
    if (parte) partes.push(parte);
  }

  const tirar = (parte) => {
    if (ligadas.has(parte)) parte.desligar();
    ligadas.delete(parte);
    partes.splice(partes.indexOf(parte), 1);
  };
  // editor de temas: a seção é trocada inteira, e as partes presas aos elementos antigos nascem de novo
  document.addEventListener('shopify:section:unload', (evento) => {
    partes.filter((p) => (p.kit && evento.target.contains(p.kit)) || (p.dono && evento.target.contains(p.dono))).forEach(tirar);
  });
  document.addEventListener('shopify:section:load', (evento) => {
    if (evento.target.querySelector('nt-buy-kit')) {
      partes.filter((p) => p.kit).forEach(tirar);
      for (const parte of partesDoKit()) {
        if (parte) partes.push(parte);
      }
    }
    sincronizar();
  });

  // ---------- filtros da vitrine ----------

  // abaixo de 750px os filtros viram uma fileira que corre de lado. o filtro ativo precisa estar à vista,
  // inclusive o que chega pelo menu (/products?categoria=face-tracking), que é o último da fileira.
  // a fileira rola sozinha até ele; a página não se mexe. acima de 750px ela quebra em linhas e não rola
  function filtrosDaVitrine(fileira) {
    const secao = fileira.closest('.nt-products');
    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    let vigia = null;

    const mostrar = (chip, animar) => {
      if (!chip || fileira.scrollWidth <= fileira.clientWidth + 1) return;
      const caixa = fileira.getBoundingClientRect();
      const b = chip.getBoundingClientRect();
      const folga = parseFloat(getComputedStyle(fileira).paddingLeft) || 0;
      if (b.left >= caixa.left + folga && b.right <= caixa.right - folga) return;
      const alvo = fileira.scrollLeft + (b.left - caixa.left) - (caixa.width - b.width) / 2;
      fileira.scrollTo({ left: Math.max(0, alvo), behavior: animar && !semMovimento.matches ? 'smooth' : 'auto' });
    };
    // o filtro da seção troca o aria-pressed no toque e quando lê a categoria da url, antes ou depois deste arquivo
    const mudou = (registros) => {
      for (const r of registros) {
        if (r.target.getAttribute('aria-pressed') === 'true') mostrar(r.target, true);
      }
    };

    return {
      dono: secao,
      ligar() {
        mostrar(fileira.querySelector('[data-nt-chip][aria-pressed="true"]'), false);
        vigia = new MutationObserver(mudou);
        vigia.observe(fileira, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
      },
      desligar() {
        if (vigia) vigia.disconnect();
        vigia = null;
      },
    };
  }

  // ---------- novidades ----------

  // na home os lançamentos passam de lado, um cartão por vez. o título da seção mora na mesma coluna
  // das faixas, e a rolagem lateral precisa de uma caixa só com elas: esta parte cria a caixa, que fora
  // do celular fica sem caixa própria e deixa as faixas como estavam. o seletor é o mesmo do nt-mobile.css
  const NOVIDADES = '[id$="__novidades"] > .nt-dest';
  function novidades(secao) {
    const coluna = secao.querySelector(':scope > .nt-wrap');
    const faixas = coluna ? [...coluna.querySelectorAll(':scope > .nt-dest__row')] : [];
    // nos formatos carrossel e capa as faixas não moram na coluna, e com uma só não há o que passar
    if (faixas.length < 2) return null;

    const trilho = document.createElement('div');
    trilho.className = 'nt-m-dest__trilho';
    const pontos = document.createElement('div');
    pontos.className = 'nt-m-dest__pontos';
    pontos.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < faixas.length; i++) {
      const ponto = document.createElement('span');
      ponto.className = 'nt-m-dest__ponto';
      pontos.append(ponto);
    }
    let vigia = null;
    let medida = null;

    const marcar = (i) => {
      [...pontos.children].forEach((ponto, n) => ponto.classList.toggle('is-atual', n === i));
    };
    const viu = (entradas) => {
      for (const entrada of entradas) {
        if (entrada.isIntersecting && entrada.intersectionRatio >= 0.6) marcar(faixas.indexOf(entrada.target));
      }
    };
    // no tablet os cartões cabem todos na largura e não há para onde passar: os pontos saem
    const conferir = () => {
      pontos.hidden = trilho.scrollWidth - trilho.clientWidth < 2;
    };
    // editor de temas: o bloco escolhido na lateral vem para a frente
    const escolheu = (evento) => {
      const i = faixas.indexOf(evento.target);
      if (i >= 0) trilho.scrollTo({ left: faixas[i].offsetLeft - faixas[0].offsetLeft, behavior: 'auto' });
    };

    return {
      dono: secao,
      ligar() {
        // as faixas entram no trilho uma vez só: tirar e pôr de volta reconectaria o vídeo do cartão,
        // que soma ouvintes a cada vez. fora do celular o trilho fica sem caixa (display: contents)
        if (!trilho.isConnected) {
          faixas[0].before(trilho);
          trilho.append(...faixas);
        }
        trilho.style.display = '';
        secao.append(pontos);
        marcar(0);
        conferir();
        vigia = new IntersectionObserver(viu, { root: trilho, threshold: 0.6 });
        faixas.forEach((faixa) => vigia.observe(faixa));
        if ('ResizeObserver' in window) {
          medida = new ResizeObserver(conferir);
          medida.observe(trilho);
        }
        document.addEventListener('shopify:block:select', escolheu);
      },
      desligar() {
        document.removeEventListener('shopify:block:select', escolheu);
        if (vigia) vigia.disconnect();
        if (medida) medida.disconnect();
        vigia = null;
        medida = null;
        trilho.style.display = 'contents';
        pontos.remove();
      },
    };
  }

  // ---------- jogos compatíveis ----------

  // no celular a faixa de jogos segue andando sozinha, como no desktop, e o dedo também passa por ela.
  // a fileira vira rolagem do próprio navegador e o script empurra essa rolagem a cada quadro; o dedo,
  // a roda ou o mouse em cima param a faixa, e ela volta a andar quando a pessoa larga e a rolagem assenta.
  // o laço precisa de jogo dos dois lados para o dedo poder voltar: a parte soma cópias às que o
  // <nt-marquee> já faz e mantém a posição entre uma e duas voltas do começo, onde a vista é igual à
  // de uma volta antes e à de uma volta depois
  function faixaDeJogos(faixa) {
    const trilho = faixa.querySelector('[data-nt-track]');
    if (!trilho) return null;
    const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    const velocidade = Number(faixa.dataset.speed) || 60;
    // quanto a faixa espera parada depois que a pessoa larga, contado de quando a rolagem assenta
    const esperas = { lado: 2500, toque: 1500, mouse: 300 };
    // sem rolagem por esse tempo, o arraste e o embalo acabaram (o safari 17 não tem scrollend)
    const assenta = 160;
    // ao voltar, a faixa ganha velocidade aos poucos
    const rampa = 600;

    let ativa = false;
    let itens = 0;
    let volta = 0;
    let pos = 0;
    let escrito = -1;
    let quadro = 0;
    let ultimo = null;
    let fator = 1;
    let pessoa = false;
    let toque = null;
    let mouse = false;
    let espera = esperas.toque;
    let soltou = 0;
    let mexeu = 0;
    let relogio = 0;
    let naTela = false;
    let vigia = null;
    let mutacoes = null;

    // o tamanho da sequência é o que o <nt-marquee> guardou. com movimento reduzido ele nem começa o laço
    // e não guarda nada: aí a sequência vai do começo do trilho até a primeira cópia, que vem com aria-hidden
    const contar = () => {
      if (Number.isInteger(faixa.originalCount) && faixa.originalCount > 0) return faixa.originalCount;
      let i = 0;
      for (const filho of trilho.children) {
        if (filho.hasAttribute('aria-hidden')) break;
        i++;
      }
      return i;
    };
    const medir = () => trilho.children[itens].getBoundingClientRect().left - trilho.children[0].getBoundingClientRect().left;
    // a mesma vista existe uma volta antes e uma depois: a posição volta para a faixa do meio
    const meio = (x) => {
      const resto = (((x - volta) % volta) + volta) % volta;
      return volta + resto;
    };
    const escrever = (x) => {
      faixa.scrollLeft = x;
      escrito = faixa.scrollLeft;
    };
    // o leitor de tela ouve uma sequência só. no laço é a que mora onde a faixa anda, entre a primeira e a
    // segunda volta; a primeira fica sempre fora da tela. fora do laço volta o arranjo do <nt-marquee>
    const anunciar = (noLaco) => {
      [...trilho.children].forEach((filho, i) => {
        if (noLaco ? i >= itens && i < 2 * itens : i < itens) filho.removeAttribute('aria-hidden');
        else filho.setAttribute('aria-hidden', 'true');
      });
    };
    // folga de uma volta inteira depois da posição mais à frente do laço, para o dedo e o embalo
    const completar = () => {
      const falta = Math.ceil((3 * volta - (faixa.scrollWidth - faixa.clientWidth)) / volta);
      if (falta > 0) {
        const modelo = [...trilho.children].slice(0, itens);
        const copias = [];
        for (let k = 0; k < falta; k++) {
          for (const item of modelo) {
            const copia = item.cloneNode(true);
            copia.setAttribute('aria-hidden', 'true');
            copia.setAttribute('data-nt-m-copia', '');
            copias.push(copia);
          }
        }
        // tudo entra de novo de uma vez: o mascote recomeça o passo junto em todas as cópias,
        // e a volta do laço não troca o da tela por um em outro passo
        trilho.replaceChildren(...trilho.children, ...copias);
      }
      if (mutacoes) mutacoes.takeRecords();
    };

    const marcar = () => {
      if (!ativa) return;
      faixa.classList.toggle('nt-m-jogos-parado', pessoa || semMovimento.matches);
      faixa.classList.toggle('nt-m-jogos-fora', !naTela || document.hidden);
    };
    const anda = () => ativa && !pessoa && naTela && !document.hidden && !semMovimento.matches;
    const passo = (agora) => {
      quadro = 0;
      if (!anda()) return;
      const dt = ultimo === null ? 0 : Math.min(agora - ultimo, 50);
      ultimo = agora;
      fator = Math.min(1, fator + dt / rampa);
      pos += (velocidade * fator * dt) / 1000;
      if (pos >= 2 * volta) pos = meio(pos);
      escrever(pos);
      quadro = requestAnimationFrame(passo);
    };
    const parar = () => {
      if (quadro) cancelAnimationFrame(quadro);
      quadro = 0;
    };
    const seguir = () => {
      marcar();
      if (anda() && !quadro) {
        ultimo = null;
        quadro = requestAnimationFrame(passo);
      }
    };

    // a pessoa pegou a faixa: ela para onde está e só a pessoa mexe nela
    const pegar = (tipo) => {
      pessoa = true;
      espera = esperas[tipo];
      parar();
      clearTimeout(relogio);
      relogio = 0;
      marcar();
    };
    const retomar = () => {
      pessoa = false;
      // a pessoa pode ter deixado a faixa perto de uma ponta; a mesma vista no meio devolve a folga
      pos = meio(faixa.scrollLeft);
      escrever(pos);
      fator = 0;
      seguir();
    };
    const conferir = () => {
      relogio = 0;
      if (!pessoa || toque || mouse) return;
      const agora = performance.now();
      const calma = agora - mexeu;
      if (calma < assenta) {
        relogio = setTimeout(conferir, assenta - calma);
        return;
      }
      const falta = Math.max(soltou, mexeu) + espera - agora;
      if (falta > 0) {
        relogio = setTimeout(conferir, falta);
        return;
      }
      retomar();
    };

    // rolagem que não foi escrita aqui é da pessoa: arraste, embalo, roda, teclado ou busca na página
    const rolou = () => {
      if (!ativa) return;
      const atual = faixa.scrollLeft;
      if (Math.abs(atual - escrito) < 1) return;
      if (!pessoa) pegar('lado');
      pos = atual;
      mexeu = performance.now();
      espera = esperas.lado;
      if (!relogio) conferir();
    };

    // o fim do toque chega no elemento tocado mesmo se o <nt-marquee> refizer o trilho no meio do gesto
    const largarAlvo = (t) => {
      t.alvo.removeEventListener('touchmove', arrastou);
      t.alvo.removeEventListener('touchend', largou);
      t.alvo.removeEventListener('touchcancel', largou);
    };
    // um dedo manda na faixa por vez; o segundo dedo de uma pinça não troca quem manda
    const seguirDedo = (p, alvo) => {
      toque = { id: p.identifier, x: p.clientX, y: p.clientY, eixo: '', alvo };
      alvo.addEventListener('touchmove', arrastou, { passive: true });
      alvo.addEventListener('touchend', largou);
      alvo.addEventListener('touchcancel', largou);
    };
    const tocou = (evento) => {
      if (!ativa) return;
      if (toque && evento.touches.length > 1) return;
      if (toque) largarAlvo(toque);
      seguirDedo(evento.changedTouches[0], evento.target);
      pegar('toque');
      // cada gesto começa com uma volta inteira de folga para os dois lados. a vista é a mesma, e quem
      // passa para trás várias vezes seguidas não encosta no começo da fileira
      pos = meio(faixa.scrollLeft);
      escrever(pos);
    };
    const arrastou = (evento) => {
      if (!toque || toque.eixo) return;
      const p = [...evento.touches].find((q) => q.identifier === toque.id);
      if (!p) return;
      const dx = Math.abs(p.clientX - toque.x);
      const dy = Math.abs(p.clientY - toque.y);
      if (dx < 8 && dy < 8) return;
      toque.eixo = dx > dy ? 'x' : 'y';
      if (toque.eixo === 'x') {
        espera = esperas.lado;
        return;
      }
      // o dedo de pé rola a página: a faixa não era o alvo e segue andando
      pessoa = false;
      fator = 0;
      seguir();
    };
    const largou = (evento) => {
      const t = toque;
      if (!t) return;
      // o dedo que saiu é outro: o que manda continua na faixa
      if (![...evento.changedTouches].some((p) => p.identifier === t.id)) return;
      largarAlvo(t);
      toque = null;
      // saiu o que mandava, mas outro dedo segue na faixa: ele passa a mandar, e a faixa segue parada
      const outro = [...evento.touches].find((p) => p.target instanceof Node && faixa.contains(p.target));
      if (outro) {
        seguirDedo(outro, outro.target);
        return;
      }
      if (!pessoa) return;
      soltou = performance.now();
      conferir();
    };

    // com mouse a faixa para enquanto ele está em cima, como no desktop. o movimento também conta: a janela
    // pode estreitar com o mouse já parado em cima, e aí a entrada não acontece de novo
    const entrou = (evento) => {
      if (!ativa || evento.pointerType !== 'mouse' || mouse) return;
      mouse = true;
      pegar('mouse');
    };
    const saiu = (evento) => {
      if (evento.pointerType !== 'mouse' || !mouse) return;
      mouse = false;
      soltou = performance.now();
      conferir();
    };
    // roda de lado (ou com shift) é da faixa; a de pé rola a página e a faixa segue
    const rodou = (evento) => {
      if (!ativa || (Math.abs(evento.deltaX) <= Math.abs(evento.deltaY) && !evento.shiftKey)) return;
      if (!pessoa || espera !== esperas.lado) pegar('lado');
      mexeu = performance.now();
      if (!relogio) conferir();
    };

    const viu = (entradas) => {
      naTela = entradas[entradas.length - 1].isIntersecting;
      if (!naTela) parar();
      seguir();
    };
    const mudouAba = () => {
      if (document.hidden) parar();
      seguir();
    };
    const mudouPreferencia = () => {
      if (semMovimento.matches) parar();
      seguir();
    };

    // monta o laço, e remonta quando o <nt-marquee> refaz o trilho: ele mede uma sequência sozinha a cada
    // mudança de tamanho (no iphone, também quando a barra do safari some), a rolagem cai para dentro dela
    // e as cópias da parte somem. tudo volta aqui, antes da pintura, no mesmo lugar
    const montar = () => {
      itens = contar();
      // sem cópias não há laço: no editor de temas, ou enquanto o <nt-marquee> não conseguiu medir
      // sem laço a fileira fica parada, de passar com o dedo: a animação do desktop sem a distância medida
      // andaria meia fileira e voltaria. vale também para quem desliga o movimento reduzido com a página
      // aberta, porque o <nt-marquee> só lê a preferência quando nasce
      if (!itens || trilho.children.length < 2 * itens) {
        if (ativa) {
          ativa = false;
          parar();
          anunciar(false);
          faixa.classList.remove('nt-m-jogos-on', 'nt-m-jogos-parado', 'nt-m-jogos-fora');
          faixa.scrollLeft = 0;
        }
        faixa.classList.add('nt-m-jogos-sem-laco');
        return;
      }
      if (!ativa) {
        // a faixa já andava pela animação do desktop: a rolagem continua de onde ela estava
        const t = getComputedStyle(trilho).transform;
        const andado = t && t !== 'none' ? -new DOMMatrixReadOnly(t).m41 : 0;
        faixa.classList.remove('nt-m-jogos-sem-laco');
        faixa.classList.add('nt-m-jogos-on');
        ativa = true;
        volta = medir();
        if (!(volta > 0)) {
          ativa = false;
          faixa.classList.remove('nt-m-jogos-on');
          faixa.classList.add('nt-m-jogos-sem-laco');
          return;
        }
        completar();
        pos = meio(volta + andado);
      } else {
        const antes = volta;
        const medida = medir();
        if (medida > 0) volta = medida;
        completar();
        // a largura da tela mudou o tamanho dos cartões: o mesmo ponto da sequência continua na tela
        if (antes > 0 && Math.abs(volta - antes) > 0.5) pos = (pos / antes) * volta;
        if (!pessoa) pos = meio(pos);
      }
      anunciar(true);
      escrever(pos);
      seguir();
    };
    const refez = () => {
      if (celular.matches) montar();
    };

    const ouvirPreferencia = (ligado) => {
      if (semMovimento.addEventListener) semMovimento[ligado ? 'addEventListener' : 'removeEventListener']('change', mudouPreferencia);
      else semMovimento[ligado ? 'addListener' : 'removeListener'](mudouPreferencia);
    };

    return {
      dono: faixa,
      ligar() {
        ativa = false;
        pessoa = false;
        toque = null;
        mouse = false;
        fator = 1;
        volta = 0;
        escrito = -1;
        naTela = false;
        mutacoes = new MutationObserver(refez);
        mutacoes.observe(trilho, { childList: true });
        vigia = new IntersectionObserver(viu);
        vigia.observe(faixa);
        faixa.addEventListener('scroll', rolou, { passive: true });
        faixa.addEventListener('touchstart', tocou, { passive: true });
        faixa.addEventListener('wheel', rodou, { passive: true });
        faixa.addEventListener('pointerenter', entrou);
        faixa.addEventListener('pointermove', entrou);
        faixa.addEventListener('pointerleave', saiu);
        document.addEventListener('visibilitychange', mudouAba);
        ouvirPreferencia(true);
        montar();
      },
      desligar() {
        parar();
        clearTimeout(relogio);
        relogio = 0;
        if (mutacoes) mutacoes.disconnect();
        if (vigia) vigia.disconnect();
        mutacoes = null;
        vigia = null;
        if (toque) largarAlvo(toque);
        toque = null;
        faixa.removeEventListener('scroll', rolou, { passive: true });
        faixa.removeEventListener('touchstart', tocou, { passive: true });
        faixa.removeEventListener('wheel', rodou, { passive: true });
        faixa.removeEventListener('pointerenter', entrou);
        faixa.removeEventListener('pointermove', entrou);
        faixa.removeEventListener('pointerleave', saiu);
        document.removeEventListener('visibilitychange', mudouAba);
        ouvirPreferencia(false);
        if (itens) anunciar(false);
        trilho.querySelectorAll(':scope > [data-nt-m-copia]').forEach((copia) => copia.remove());
        faixa.classList.remove('nt-m-jogos-on', 'nt-m-jogos-parado', 'nt-m-jogos-fora', 'nt-m-jogos-sem-laco');
        faixa.scrollLeft = 0;
        ativa = false;
        pessoa = false;
        mouse = false;
      },
    };
  }

  // ---------- perguntas frequentes ----------

  // no celular cada aba abre com as 6 primeiras perguntas e um botão mostra o resto ali mesmo.
  // as outras continuam no html e no json-ld; o corte é só da tela, e só entra junto com o botão
  function perguntas(caixa) {
    // na página de suporte as perguntas são o próprio conteúdo da página: a lista fica inteira
    if (document.querySelector('.nt-sup')) return null;
    const primeiras = 6;
    const grupos = [...caixa.querySelectorAll('[data-nt-faq-group]')];
    const itens = (grupo) => [...grupo.querySelectorAll(':scope > .nt-faq__item')];
    if (!grupos.some((grupo) => itens(grupo).length > primeiras)) return null;

    const botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'nt-m-faq__mais';
    let aberta = false;

    const naTela = () => grupos.filter((grupo) => !grupo.hidden);
    // o total acompanha a aba, e numa aba com 6 ou menos o botão sai
    const desenhar = () => {
      const visiveis = naTela();
      const total = visiveis.reduce((soma, grupo) => soma + itens(grupo).length, 0);
      const esconder = aberta || !visiveis.some((grupo) => itens(grupo).length > primeiras);
      if (botao.hidden !== esconder) botao.hidden = esconder;
      const texto = `Ver todas as ${total} perguntas`;
      if (botao.textContent !== texto) botao.textContent = texto;
    };
    // o botão some no toque; o foco vai antes para a primeira pergunta nova, e o teclado e o leitor de tela seguem dali
    const abrir = (focar) => {
      aberta = true;
      caixa.classList.remove('nt-m-faq-curta');
      const primeira = naTela().map((grupo) => itens(grupo)[primeiras]).find(Boolean);
      const resumo = primeira && primeira.querySelector('summary');
      if (focar && resumo) resumo.focus();
      desenhar();
    };
    const clicou = () => abrir(true);
    // editor de temas: o bloco escolhido pode ser uma das perguntas cortadas
    const escolheu = () => abrir(false);
    // a troca de aba é da seção, que só mexe no hidden dos grupos
    const observador = new MutationObserver(desenhar);

    return {
      dono: caixa,
      ligar() {
        if (!aberta) caixa.classList.add('nt-m-faq-curta');
        caixa.append(botao);
        desenhar();
        grupos.forEach((grupo) => observador.observe(grupo, { attributes: true, attributeFilter: ['hidden'] }));
        botao.addEventListener('click', clicou);
        caixa.addEventListener('shopify:block:select', escolheu);
      },
      desligar() {
        observador.disconnect();
        botao.removeEventListener('click', clicou);
        caixa.removeEventListener('shopify:block:select', escolheu);
        caixa.classList.remove('nt-m-faq-curta');
        botao.remove();
      },
    };
  }

  const partesDaHome = (raizBusca) => [
    ...[...raizBusca.querySelectorAll('.nt-products .nt-chips')].map(filtrosDaVitrine),
    ...[...raizBusca.querySelectorAll(NOVIDADES)].map(novidades),
    ...[...raizBusca.querySelectorAll('nt-faq')].map(perguntas),
    ...[...raizBusca.querySelectorAll('nt-marquee.nt-marquee')].map(faixaDeJogos),
  ];
  for (const parte of partesDaHome(document)) {
    if (parte) partes.push(parte);
  }
  // a saída da seção no editor já é tratada pelo dono; aqui só nascem as partes da seção nova
  document.addEventListener('shopify:section:load', (evento) => {
    for (const parte of partesDaHome(evento.target)) {
      if (parte) partes.push(parte);
    }
    sincronizar();
  });

  for (const midia of [celular, configurador]) {
    if (midia.addEventListener) midia.addEventListener('change', sincronizar);
    else midia.addListener(sincronizar);
  }
  sincronizar();
})();
